import { useEffect, useRef } from "react"

import { useToast } from "@be-miniapp/ui/hooks/use-toast"

export function usePaymentMethodToastOnFare(
  paymentMethod: { toast_msg?: string } | undefined
) {
  const { toast } = useToast()
  const lastToastMessage = useRef<string | undefined>(undefined)
  const toastMessage = paymentMethod?.toast_msg

  useEffect(() => {
    if (!toastMessage) {
      lastToastMessage.current = undefined
      return
    }

    if (lastToastMessage.current === toastMessage) {
      return
    }

    lastToastMessage.current = toastMessage
    const paymentToast = toast({
      description: toastMessage,
    })
    const t = setTimeout(() => {
      paymentToast.dismiss()
    }, 5000)

    return () => {
      clearTimeout(t)
      paymentToast.dismiss()
    }
  }, [toast, toastMessage])
}
